import React from 'react';
import { motion } from 'framer-motion';
export function EmotionalValidation() {
  return <section className="py-20 md:py-24 bg-white px-4 sm:px-6 lg:px-8" data-id="element-30">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center" data-id="element-31">
        {/* Image of frustrated/stressed young woman */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative order-1 lg:order-1" data-id="element-32">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-33">
            <img src="https://cdn.magicpatterns.com/uploads/aerreYEeqm8txX5QPeekgJ/ChatGPT_Image_21_may_2026,_07_52_42_p.m..png" alt="Mujer joven con dolor de cabeza por premenstrual" className="w-full h-[400px] md:h-[550px] object-cover object-center" data-id="element-34" />
            <div className="absolute inset-0 bg-gradient-to-t from-burgundy/30 via-transparent to-transparent" data-id="element-35"></div>
          </div>
          <div className="absolute -top-6 -left-6 w-24 h-24 bg-burgundy/10 rounded-full blur-2xl -z-10" data-id="element-36"></div>
          <div className="absolute -bottom-8 -right-8 w-32 h-32 bg-gold/15 rounded-full blur-3xl -z-10" data-id="element-37"></div>
        </motion.div>

        {/* Copy */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="order-2 lg:order-2 text-center lg:text-left" data-id="element-38">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-burgundy mb-8 italic leading-tight" data-id="element-39">
            "No estás loca. Estás en una montaña rusa hormonal"
          </h2>

          <div className="space-y-5 text-base md:text-lg text-gray-800 leading-relaxed" data-id="element-40">
            <p data-id="element-41">
              Tu cuerpo simplemente necesita otro tipo de cuidado esos días.
            </p>
            <p data-id="element-42">
              El problema es que nadie te enseñó qué hacer antes de que el
              premenstrual te agarre desprevenida.
            </p>
            <p className="font-bold text-dark text-xl" data-id="element-43">Entonces improvisás.</p>
          </div>

          <p className="text-2xl md:text-3xl font-bold text-burgundy mt-10 font-serif italic" data-id="element-44">
            Necesitabas esto 👇
          </p>
        </motion.div>
      </div>
    </section>;
}